module.exports = __webpack_public_path__ + "img/domicile-3.604e877d.jpg";